import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import GLightbox from 'glightbox';
import collapse from "@alpinejs/collapse";

Alpine.plugin(collapse);


const hamburger = document.querySelector(".hamburger");
if (hamburger) {
	hamburger.addEventListener("click", (e) => {
		document.querySelector(".navigation").classList.toggle('hidden');
		hamburger.querySelector('.icon-close').classList.toggle('opacity-0');
		hamburger.querySelector('.icon-menu').classList.toggle('opacity-0');
	}, false);
}

 // Swiper: Slider
const heroSwiper = new Swiper('.hero_carousel', {
	loop: false,
	slidesPerView: 1,
	paginationClickable: true,
	pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
	autoplay: {
		delay: 10000,
		disableOnInteraction: false
	},
});

// Testimonail Slider
const testimonailSwiper = new Swiper('.testimonial_carousel', {
	loop: true,
	slidesPerView: 1,
	autoHeight: true,
	// paginationClickable: true,
	navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
	pagination: {
        el: '.swiper-pagination',
        clickable: true,
    }
});

// product slider
var swiper = new Swiper(".product_slider", {
	slidesPerView: 4,
	spaceBetween: 0,
	gap: 0,
	breakpoints: {
	  	320:{
			slidesPerView: 1,
			spaceBetween: 0,
	  	},
  		640: {
			slidesPerView: 2,
			spaceBetween: 0,
  		},
  		992: {
			slidesPerView: 4,
			spaceBetween: 0,
  		},
	},
	navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    }
});

const lightboxVideo = GLightbox({
	selector: '.gl-video'
});

// smooth Scroll
const links = document.querySelectorAll('.js-scroll');
links.forEach(function (el) {
    el.addEventListener('click', smoothScroll)
});

function smoothScroll(e) {

    e.preventDefault();

    const link = this.getAttribute("href");

    const offsetTop = document.querySelector(link).scrollIntoView({
     	behavior: 'smooth'
	});
}

// border active on sub menu
const mapFixed = document.getElementById('google-map');
if(mapFixed)
{
	const section = document.querySelectorAll(".scroll");
	const subNavbar = document.querySelector('.sub-navbar');
	var fixed = null ;
	var fixed2 = null;
	if (subNavbar) {
		fixed = subNavbar.offsetTop;
	}

	document.addEventListener("scroll", () => {
	  	if (subNavbar) {
			if (window.pageYOffset >= fixed) {
				subNavbar.classList.add('lg:fixed');
			}else{
				subNavbar.classList.remove('lg:fixed');
			}
		}
		if (mapFixed) {
			if (window.pageYOffset >= mapFixed.offsetTop && window.pageYOffset + window.innerHeight - (mapFixed.offsetTop + mapFixed.scrollHeight) <= 0) {
				mapFixed.querySelector('#fixed-map').classList.add('lg:!fixed', 'top-0');
			}else if(window.pageYOffset + window.innerHeight - (mapFixed.offsetTop + mapFixed.scrollHeight) >= 0){
				mapFixed.querySelector('#fixed-map').classList.remove('lg:!fixed', 'top-0');
				mapFixed.querySelector('#fixed-map').classList.add('bottom-0', 'lg:absolute');
			}else{
				mapFixed.querySelector('#fixed-map').classList.remove('lg:!fixed');
			}
		}

	  	links.forEach(function(el){
	  		el.querySelector('.active-border').classList.remove('opacity-100');
	  	});

		section.forEach(function(el, index){
			if (el.offsetTop - 65 <= window.pageYOffset && (el.offsetTop + el.offsetHeight) - 65 > window.pageYOffset) {
				document.querySelector('a[href*=' + el.id + ']').querySelector('.active-border').classList.add('opacity-100');
			}
		});
	});

	// hide show for reseller
	let continentForm = document.querySelector("#continent-form #continent");
	let newMarkers;
	if (continentForm) {
		continentForm.addEventListener("change", (el)=>{
			// scroll top map div
			if (screen.width > 1023) {
				const scrollTop = el.target.scrollIntoView({
			     	behavior: "smooth"
				});
			}

			el.target.parentElement.parentElement.parentElement.querySelectorAll('[data-continent]').forEach(function(e){
				if (el.target.value) {
					e.classList.add('hidden');
				}else{
					e.classList.remove('hidden');
				}
			});

			if (el.target.value) {
				el.target.parentElement.parentElement.parentElement.querySelector('[data-continent="' + el.target.value + '"]').classList.remove("hidden");
			}

			initMap(el.target.value);
		});
	}

	// init Map
	let pushMarkers = [];
	let infoWindow = new google.maps.InfoWindow();
	let infoContent = {};

	function initMap(type) {

		let markerId = document.getElementById("map");
		let markers = markerId ? JSON.parse(markerId.dataset.markers) : '';
		let newMarkers = [];
		let bounds = new google.maps.LatLngBounds();
		const icon = {
		    url: '/assets/images/ge-pin.png', // url
		    scaledSize: new google.maps.Size(25, 35), // scaled size
		};

		const map = new google.maps.Map(markerId, {
	    	zoom: 8,
	    	minZoom: 2,
	    	restriction: {
		    	latLngBounds: {
		      		north: 85,
					south: -85,
					west: -180,
					east: 180
		    	},
		  	},
	  	});

		if (type) {
			for (var i = 0; i < markers.length; i++) {
				if (markers[i].type == type) {
					newMarkers.push(markers[i])
				}
			}
			markers = newMarkers;
		}

	  	markers.forEach(setMarkers);

		function setMarkers(item, index) {
			var myLatlng = new google.maps.LatLng(item.lat, item.lng);
			var marker = new google.maps.Marker({
			    position: myLatlng,
				title: item.key,
				icon: icon
			});

	    	infoContent[item.key] = `<div class="shadow-[0px_0px_20px_-8px]">
				<h4 class="lg:text-lg text-sm font-serif text-black mb-2">${item.title}</h4>
					<p class="w-full mb-4">${item.address}</p>
				<div class="flex flex-wrap items-center gap-5">
					<a href="${item.phone}" class="hover:text-blue-500 focus:outline-0">
						<svg class="icon--phone icon text-blue-500 hover:text-orange-500 transition-all h-5 w-5">
							<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon--phone" aria-labelledby="title__phone">
								<title id="title__phone"></title>
							</use>
						</svg>
					</a>
					<a href="javascript:;" data-email="${item.email}" data-title="${item.title}" onclick="toggleModal(); resellerForm(this);" class="trigger-form hover:text-blue-500">
						<svg class="icon--email icon text-blue-500 hover:text-orange-500 transition-all h-5 w-5">
							<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon--email" aria-labelledby="title__email">
								<title id="title__email"></title>
							</use>
						</svg>
					</a>
					<a href="${item.website}" target="_blank" rel="noopener" class="hover:text-blue-500">
						<svg class="icon--globe icon text-blue-500 hover:text-orange-500 transition-all h-5 w-5">
							<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon--globe" aria-labelledby="title__globe">
								<title id="title__globe"></title>
							</use>
						</svg>
					</a>
				</div>
			</div>`;

			google.maps.event.addListener(marker, 'click', (function(marker, i) {
	            return function() {
			        infoWindow.setContent(`<div class="shadow-[0px_0px_20px_-8px]">
						<h4 class="lg:text-lg text-sm font-serif text-black mb-2">${item.title}</h4>
							<p class="w-full mb-4">${item.address}</p>
						<div class="flex flex-wrap items-center gap-5">
							<a href="${item.phone}" class="hover:text-blue-500 focus:outline-0">
								<svg class="icon--phone icon text-blue-500 hover:text-orange-500 transition-all h-5 w-5">
									<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon--phone" aria-labelledby="title__phone">
										<title id="title__phone"></title>
									</use>
								</svg>
							</a>
							<a href="javascript:;" data-email="${item.email}" data-title="${item.title}" onclick="toggleModal(); resellerForm(this);" class="trigger-form hover:text-blue-500">
								<svg class="icon--email icon text-blue-500 hover:text-orange-500 transition-all h-5 w-5">
									<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon--email" aria-labelledby="title__email">
										<title id="title__email"></title>
									</use>
								</svg>
							</a>
							<a href="${item.website}" target="_blank" rel="noopener" class="hover:text-blue-500">
								<svg class="icon--globe icon text-blue-500 hover:text-orange-500 transition-all h-5 w-5">
									<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon--globe" aria-labelledby="title__globe">
										<title id="title__globe"></title>
									</use>
								</svg>
							</a>
						</div>
					</div>`);
	                infoWindow.open(map, marker);
	                if (screen.width > 1023) {
	                	removeBg();
	                	let element = document.querySelector("[data-markerId='" + marker.title + "']");
	                	element.classList.add("bg-blue-100");
		                element.scrollIntoView({
					     	behavior: "smooth"
						});
					}
	            }
	        })(marker));
			infoWindow.addListener('closeclick', ()=>{
			  	removeBg()
			});
			function removeBg(){
				document.querySelectorAll(".hover-open-infowindow").forEach(function(el){
	        		el.classList.remove("bg-blue-100");
	        	});
			}
			// To add the marker to the map, call setMap();
			var zoomChangeBoundsListener =
		    google.maps.event.addListener(map, 'bounds_changed', function(event) {
		        google.maps.event.removeListener(zoomChangeBoundsListener);
		        map.setZoom( Math.min( 16, map.getZoom() ) );
		    });
			bounds.extend(myLatlng);
			marker.setMap(map);
			pushMarkers.push(marker);
			map.fitBounds(bounds);
		}
	}

	window.onload = function() {
	    // let's go!
		if(document.getElementById("map")) {
			initMap();
		}
	}

	// hover listing to show info popup on marker
	document.querySelectorAll(".hover-open-infowindow").forEach(function(el){
		el.addEventListener("mouseenter", function(event) {
			for ( var i = 0; i< pushMarkers.length; i++) {
		        if (this.dataset.markerid === pushMarkers[i].title) {
		        	infoWindow.setContent(infoContent[this.dataset.markerid]);
		           	infoWindow.open(map, pushMarkers[i]);

		        }
		    }
		});

		el.addEventListener("mouseleave", function(event) {
			for ( var i = 0; i< pushMarkers.length; i++) {
		        if (this.dataset.markerid === pushMarkers[i].title) {
		           	infoWindow.close(map, pushMarkers[i]);
		        }
		    }
		});
	});
}

/*let playButton = document.querySelectorAll(".play-video");

playButton.forEach(function(el){
	el.addEventListener("click", () =>{
		el.parentElement.querySelector('iframe').classList.remove('hidden');
		el.parentElement.querySelector('iframe').src += '&autoplay=1'
		el.classList.add('hidden')
		el.parentElement.querySelector('picture').classList.add('hidden')
	});
});*/

/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
 */
import Alpine from 'alpinejs';
window.Alpine = Alpine;
Alpine.start();
